
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-local_police-fill",
  "use": "icon-material-local_police-fill-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-local_police-fill\"><path d=\"M372.09-359.13 480-438.57l105.15 79.44-43.72-128.63 107.92-77.44H518.96L480-692.35 441.04-565.2H310.89l105.68 77.44zM479.98-74.78Q337.34-110.5 245.68-239.7t-91.66-283.22v-242.15L480-887.22l326.22 122.16V-523q0 154.05-91.8 283.28Q622.63-110.5 479.98-74.78\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-local_police-fill"/>
                </svg>
            );
        };

        Icon.id = "icon-material-local_police-fill";

        export default Icon;
    